import ErrorMessage from 'components/ErrorMessage'
import React from 'react'

const OTextArea = (props) => {
	const { wrapperClassName, name, inputLabel, type, placeholder, register, errors, requiredMark, ...rest } = props

	return (
		<div className={wrapperClassName ?? 'relative z-0 mb-6 w-full group'}>
			<label htmlFor={name} className='block mb-2 text-sm font-bold text-black dark:text-white'>
				{inputLabel} {requiredMark ? <span className='text-red-600'>*</span> : null}
			</label>
			<textarea
				type={type}
				name={name}
				id={name}
				rows='4'
				className='block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
				placeholder={placeholder}
				{...register}
				{...rest}
			/>

			<ErrorMessage message={errors?.[name]?.message} />
		</div>
	)
}

export default OTextArea
